// @flow

import React, { type Node } from "react";
import { bindModal, Modal, useModal, type ModalStateType } from "../../comum";

import { Translate } from "@quantum/i18n";

import { Spinner, Tab, Tabs, TabPane, TabPanes, TabList } from "@quantum/ui";

import { Atraso, RenderizacaoAtrasada } from "../../comum/Atraso";

import Relacionamentos from "./relacionamentos";
import Metodologia from "./metodologia";

import "./relacionamentos-metodologia-modal.css";

type Props = {
  children: ModalStateType => Node,
};

const RelacionamentosMetodologiaModal = ({ children }: Props) => {
  const modal = useModal("RelacionamentosMetodologiaModal");

  return (
    <>
      {children(modal)}

      <Modal
        mountOnShow
        transition
        dialogClassName="RelacionamentosMetodologiaModal"
        {...bindModal(modal)}
      >
        <Modal.Header
          className="RelacionamentosMetodologiaModal__header"
          closeButton
        >
          <Modal.Title className="RelacionamentosMetodologiaModal__header-titulo">
            <Translate>telas.tabelaTipoAtivosMedidas</Translate>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Tabs defaultActiveTab="relacionamento">
            <TabList>
              <Tab tabId="relacionamento">
                <Translate>configuracaoRelatorio.abaRelacionamento</Translate>
              </Tab>
              <Tab tabId="metodologia">
                <Translate>menuFuncionalidades.metodologia</Translate>
              </Tab>
            </TabList>

            <TabPanes>
              <TabPane
                tabId="relacionamento"
                className="RelacionamentosMetodologiaModal__tab RelacionamentosMetodologiaModal__relacionamento"
                mountOnEnter
              >
                <Atraso atraso={4000}>
                  {({ finalizado }) => (!finalizado ? <Spinner /> : null)}
                </Atraso>

                {modal.hasEntered && (
                  <RenderizacaoAtrasada atraso={500}>
                    <Relacionamentos />
                  </RenderizacaoAtrasada>
                )}
              </TabPane>

              <TabPane
                tabId="metodologia"
                className="RelacionamentosMetodologiaModal__tab RelacionamentosMetodologiaModal__metodologia"
              >
                {modal.hasEntered && (
                  <RenderizacaoAtrasada atraso={2000}>
                    <Metodologia />
                  </RenderizacaoAtrasada>
                )}
              </TabPane>
            </TabPanes>
          </Tabs>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RelacionamentosMetodologiaModal;
